module.exports = __webpack_public_path__ + "static/media/feature2evaluation.b7eecdcd.png";